<script>
import TablePage from '@/found/components/table_page';
import Modal from '@/found/components/modal';
import Form from './form';

export default {
  name: 'attendance_task_list',
  extends: TablePage,
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  components: {
    Modal,
    Form,
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { engbleStatus } = row;
      if (engbleStatus && code === 'edit' && (engbleStatus === '2' || engbleStatus === '3')) { // 审批中或者通过不能编辑
        return false;
      }
      return true;
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      console.log('id是', row.id);
      this.formConfig = {};
      this.formName = 'Form';
      if (val.code === 'add') {
        this.modalConfig.title = '新增';
        this.formConfig = {
          code: val.code,
        };
        this.openFull();
      } else if (val.code === 'edit') {
        this.modalConfig.title = '编辑';
        this.formConfig = {
          code: val.code,
          row,
          ...val,
        };
        this.openFull();
      } else if (val.code === 'view') {
        this.modalConfig.title = '查看';
        this.formConfig = {
          ...val,
          row,
          code: val.code,
        };
        this.openFull();
      }
    },
  },
  created() {
    this.getConfigList('attendance_task_list');
  },
};
</script>
